import React from "react"
import styled from "styled-components"
import classNames from "classnames"
import NavFullNav from "./NavFullNav"
import NavFullFooter from "./NavFullFooter"
import { media } from "utils/Media"

const NavFullWrap = styled.div`
	/* position: fixed; */
	width: 100vw;
	max-height: calc(100vh - ${props => props.navTop});
	/* background: ${props => props.theme.colors.gradient}; */
	z-index: 600;
	top: ${props => props.navTop};
	left: 0;
	visibility: hidden;
	height: 0;
	opacity: 0;
	transition: opacity .4s ease;
	/* padding-top: 1.3rem; */
	overflow-y: auto;

	&.active {
		visibility: visible;
		opacity: 1;
		height: 100vh;
	}
`

const NavFullInner = styled.div`
	padding-top: 1.5rem;
	background: ${props => props.theme.colors.white};
	width: 100%;
	min-height: 100%;
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	
	@media ${media.md} {
		padding-top: 7.5rem;
	}
`

const NavFull = (props) => {
	return(
		<NavFullWrap 
			className={classNames({ active: props.active })} 
			navTop={props.navTop}
		>
			<NavFullInner>
				<NavFullNav toggleNav={props.toggleNav} />
				<NavFullFooter />
			</NavFullInner>
		</NavFullWrap>
	)
}

export default NavFull